import React from "react";
import TitleValue from "../../../../models/dtos/base/TitleValue";
import DetailChartModal from "../detailCart-modal/DetailChartModal";
import HighChartVariablePieState, { HighChartVariablePieProps } from "./HighChartVariablePie.models";
import './HighChartVariablePie.scss';

export default class StudentPerformanceChart extends React.PureComponent<HighChartVariablePieProps, HighChartVariablePieState> {

    constructor(props: any) {
        super(props);
        this.state = { showModal: false };
    }

    componentDidMount() {
        this.setData();
    }

    componentDidUpdate() {
        this.setData();
    }

    closeModal = () => {
        this.setState({ showModal: false });
    }

    showResponse() {
        let Datas = this.props.Datas;
        let details: TitleValue<string>[] = [];

        Datas.map(x => {
            if (x.value != null) {
                var h = Math.floor((x.value / 60));
                var m = x.value - (h * 60);
                var time = h + " ساعت و  " + m + "دقیقه";

                details.push({ title: x.title, value: time });
            }
        })

        this.setState({
            details: details,
            showModal: true
        })
    }

    setData() {
        let Highcharts = require('highcharts');

        let dataset: any[] = [];

        if (this.props.Datas.length > 0) {
            let Datas = this.props.Datas;
            Datas.map(x => {

                if (x.value != null) {

                    let h = Math.floor((x.value / 60));
                    let m = x.value - (h * 60);
                    let time = h + " : " + m;
                    let yx = {
                        name: x.title,
                        time: time,
                        y: x.value
                    };
                    dataset.push(yx);
                }

            })
        }

        var series = [
            {
                dataLabels: {
                    style: {
                        fontSize: 14,
                        fontWeight: 1,
                        fontFamily: 'Dana-Fanum',
                    }
                },
                name: '',
                data: dataset,
                showInLegend: true,
                type: 'pie',
            }];

        let json = {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                style: {
                    fontFamily: 'Dana-Fanum',
                    fontWeight: 1
                }
            },
            title: {
                text: 'نمودار عملکرد دانش آموز '
            },

            tooltip: {
                useHTML: true,
                pointFormat: '{series.name}<br/>{point.time}<br>%{point.percentage:.1f}'
            },
            accessibility: {
                point: {
                    valueSuffix: '%'
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false,
                        format: '{point.name}<br>{point.percentage:.1f}',
                        distance: -45,
                        filter: {
                            property: 'percentage',
                            operator: '>',
                            value: 4
                        }
                    }
                }
            },
            series: series
        };


        Highcharts.chart('container', json);
    }

    render(): React.ReactNode {
        let { HasDetails } = this.props;
        let { showModal, details } = this.state;

        return (<>
            <div id="container"></div>
            {HasDetails || HasDetails == null ? <>
                <button className="btn btn-primary btn-show-modal" onClick={() => this.showResponse()}>نمایش تفصیلی نمودار</button>
            </> : <></>}
            <DetailChartModal rows={details} closeModal={this.closeModal} showModal={showModal}></DetailChartModal>
        </>)
    }
}


